import { render, staticRenderFns } from "./list-content-grid.vue?vue&type=template&id=ef628b7c&scoped=true"
import script from "./list-content-grid.vue?vue&type=script&lang=js"
export * from "./list-content-grid.vue?vue&type=script&lang=js"
import style0 from "./list-content-grid.vue?vue&type=style&index=0&id=ef628b7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef628b7c",
  null
  
)

export default component.exports